import '@shui/core/sh-table';

import { Component, booleanAttribute, input, output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sh-table',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.condensed]': 'condensed() ? "" : null',
        '[attr.emitScrollEvent]': 'emitScrollEvent() ? "" : null',
        '[attr.freeze]': 'freeze() ? "" : null',
        '[attr.lwidth]': 'lwidth() ?? null',
        '[attr.multiselect]': 'multiselect() ? "" : null',
        '[attr.mwidth]': 'mwidth() ?? null',
        '[attr.readonly]': 'readonly() ? "" : null',
        '[attr.rwidth]': 'rwidth() ?? null',
        '[attr.scrolledLeft]': 'scrolledLeft() ?? null',
        '[attr.selection-mode]': 'selectionMode() ?? null',
        '(middle-scrolled)': 'middleScrolled.emit($event)',
        '(scroll-end)': 'scrollEnd.emit($event)',
        '(slots-modified)': 'slotsModified.emit($event)',
        '(table-scroll)': 'tableScroll.emit($event)'
    }
})
export class ShTableComponent {
    /** Applies condensed row spacing. */
    public readonly condensed = input(false, { transform: booleanAttribute });

    /** When `true`, emits `scrollEnd` when the table is scrolled. */
    public readonly emitScrollEvent = input(false, { transform: booleanAttribute });

    /** Enables frozen column layout with a horizontal scrollbar for the scrollable section. */
    public readonly freeze = input(false, { transform: booleanAttribute });

    /** Width of the frozen-left block (e.g. `'30%'`). Requires `freeze`. */
    public readonly lwidth = input<string | undefined>(undefined);

    /** Allows multi-selection of rows. */
    public readonly multiselect = input(false, { transform: booleanAttribute });

    /** Width of the scrollable middle block (e.g. `'60%'`). Requires `freeze`. */
    public readonly mwidth = input<string | undefined>(undefined);

    /** Removes hover and active states from all rows. */
    public readonly readonly = input(false, { transform: booleanAttribute });

    /** Width of the frozen-right block (e.g. `'10%'`). Requires `freeze`. */
    public readonly rwidth = input<string | undefined>(undefined);

    /** Current horizontal scroll position of the scrollable block. */
    public readonly scrolledLeft = input<number | undefined>(undefined);

    /**
     * Multi-selection mode. Pass `'metakey'` to enable Ctrl/Cmd and Shift
     * keyboard-assisted selection. Use together with `multiselect`.
     */
    public readonly selectionMode = input<string | undefined>(undefined);

    /** Emitted when the horizontal scrollbar or a row in the scrollable block is scrolled (frozen table). */
    public readonly middleScrolled = output<Event>();

    /** Emitted when the scroll bar reaches the bottom of the table. */
    public readonly scrollEnd = output<Event>();

    /** Emitted when frozen table slot content is modified or added. */
    public readonly slotsModified = output<Event>();

    /** Emitted when the table is scrolled and `emitScrollEvent` is `true`. */
    public readonly tableScroll = output<Event>();
}
